import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      link: {
        textDecoration: 'underline',

        '&:active': {
          textDecoration: 'underline',
        },
      },

      icon: {
        display: 'inline-flex',
        paddingInlineStart: '5px',
        verticalAlign: 'middle',

        '> svg': {
          height: 20,
          width: 20,
        },
      },
    },

    discrete: {
      link: {
        alignItems: 'center',
        display: 'inline-flex',
        textDecoration: 'none',
        height: tokens.button.defaultSize,

        [isTouchScreen]: {
          height: tokens.button.mobileSize,
        },
      },

      icon: {
        verticalAlign: 'bottom',

        '> svg': {
          height: 'initial',
          width: 'initial',
        },
      },
    },
  } as const
}
